import { Price1, Price2, Price3, Price4, Price5 } from '@/public/icons/id';

export const pricingPlans = [
  {
    id: "pricing-basic",
    price: "700-850$",
    title: "Базовий ремонт",
    features: [
      "Cантехнічні, електромонтажні роботи",
      "Cтіни — гіпсова штукатурка, подальше її оздоблення під фарбування миючою фарбою",
      "Вікна — утеплення віконних відкосів",
      "Плитка — середнього формату, плиточні роботи",
      "Підлога — електричний підігрів підлоги у ванній кімнаті та коридорі, зносостійкий ламінат, пластиковий плінтус",
      "Стеля — натяжна, накладні світильники",
      "Двері — пустотілий ДСП/ДВП, якісна фурнітура",
      "Меблі — МДФ",
    ],
    images: [
      Price1,
      Price2,
      Price3,
      Price4,
      Price5
    ],
  },
  {
    id: "pricing-standard",
    price: "950-1100$",
    title: "Стандартний ремонт",
    features: [
      "Сантехнічні, електромонтажні роботи, дистанційне керування опаленням",
      "Стіни — гіпсова штукатурка, подальше її оздоблення під фарбування, додатковий захист від великих тріщин",
      "Вікна — утеплення віконних відкосів",
      "Плитка — середній та дрібний формат, плиточні роботи",
      "Підлога — підігрів підлоги у ванній, коридорі, кухні (електричний, водяний або комбінований), часткове або повне утеплення підлоги, вінілове покриття, ламінат, плінтуса МДФ",
      "Стеля — гіпсокартон, комбінація врізних та накладних світильників, трекові системи",
      "Двері — каркас з сосни або МДФ, якісна фурнітура",
      "Меблі — МДФ шпонований",
    ],
    images: [
      Price1,
      Price2,
      Price3,
      Price4,
      Price5
    ],
  },
  {
    id: "pricing-premium",
    price: "1500-1700$",
    title: "Преміум ремонт",
    features: [
      "Електромонтажні, сантехнічні роботи, дистанційне керування опаленням в кожній окремій кімнаті",
      "Стіни — гіпсова штукатурка, з оздобленням під фарбування зносостійкою фарбою з антибактеріальним ефектом, повний захист від тріщин будь-якого походження",
      "Двері та вікна — масив дерева: дуб, ясен, сосна, встановлюємо двері прихованого монтажу, утеплення віконних відкосів",
      "Плитка — дрібний та великий формат, плиточні роботи",
      "Підлога — водяний підігрів підлоги, її утеплення на всю площу приміщення, дерев’яна підлога, дерев’яний або металевий плінтус",
      "Стеля — гіпсокартон, шумоізоляція, тіньовий профіль з LED підсвіткою, гіпсові врізні світильники або запропонований вами інший варіант",
      "Меблі — дерево",
      "Реалізація індивідуальних дизайнерських рішень будь-якої складності",
    ],
    images: [
      Price1,
      Price2,
      Price3,
      Price4,
      Price5
    ],
  },
]

export const pricingOptions = [
  { id: "pricing-basic", price: "700-850$", label: "м²" },
  { id: "pricing-standard", price: "950-1100$", label: "м²" },
  { id: "pricing-premium", price: "1500-1700$", label: "м²" },
]